module.exports = __webpack_public_path__ + "static/media/huoshishanadj.e992105c.png";